import { initialValidations } from "_common/ssrWrapper";
import EmptyPage              from "_components/atoms/emptyView";

const MyError = ( { msg } ) => {
	return (
		<EmptyPage customMsg = { msg } />
	);
};

const getServerSideProps = async context => initialValidations ( context, async defaultProps => {
	/* context.res.setHeader (
    "Cache-Control",
    "public, s-maxage=30, stale-while-revalidate=120"
  ); */

	return {
		props: {
			...defaultProps
		}
	};
} );

export { getServerSideProps };

export default MyError;
